import React, { useState } from "react";
import { SignInDialog } from "users/auth/dialog/SignInDialog";

export function SignInPage() {
    const [open, setOpen] = useState(true);
    return (
        <div>
            <SignInDialog open={open} setOpen={setOpen} notClose={true} />
        </div>
    );
}
